<app-top-nav></app-top-nav>
<div class="container">
  <div class="main-content">
    <div class="header-section">
      <h1>Succession Plan</h1>
      <div class="header-actions">
        <button class="btn-new-job">New Job</button>
        <div class="action-buttons">
          <button class="btn-action">
            <span class="icon">🔍</span>
            Search
          </button>
          <button class="btn-action">
            <span class="icon">🔽</span>
            Filter
          </button>
          <button class="btn-action">
            <span class="icon">↕️</span>
            Sort
          </button>
        </div>
      </div>
    </div>

    <div class="succession-list">
      <div
        class="succession-card"
        *ngFor="let plan of successionPlans"
        [class.expanded]="isExpanded(plan.id)"
      >
        <div class="card-content" (click)="toggleExpansion(plan.id, $event)">
          <div class="card-header">
            <h3>{{ plan.title }}</h3>
            <button class="view-more-btn">
              {{ isExpanded(plan.id) ? "View Less" : "View more" }}
            </button>
          </div>

          <div class="card-tags">
            <span class="tag status-tag">{{ plan.status }}</span>
            <span class="tag experience-tag">{{ plan.experience }}</span>
            <span class="tag incumbent-tag">{{ plan.incumbent }}</span>
            <span class="tag description-tag">{{ plan.description }}</span>
          </div>

          <div class="card-description">
            <p>{{ plan.details }}</p>
          </div>
        </div>

        <!-- Expanded content with candidates -->
        <div class="expanded-content" *ngIf="isExpanded(plan.id)">
          <div class="suggested-successors-header">
            <p>{{ plan.suggestedSuccessors }}</p>
          </div>

          <div class="candidates-grid">
            <div
              class="candidate-card"
              *ngFor="let candidate of plan.candidates"
            >
              <div class="candidate-avatar">
                <span>{{ candidate.avatar }}</span>
              </div>
              <div class="candidate-info">
                <h4>{{ candidate.name }}</h4>
                <p class="candidate-role">{{ candidate.role }}</p>
                <span
                  class="candidate-status"
                  [ngClass]="getStatusClass(candidate.status)"
                >
                  {{ candidate.status }}
                </span>
                <p class="candidate-description">{{ candidate.description }}</p>
              </div>
            </div>

            <!-- Add new candidate card -->
            <div class="add-candidate-card">
              <div class="add-candidate-content">
                <span class="add-candidate-text">Add new candidate</span>
                <div class="add-candidate-icon">+</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
